import { compose, withProps } from 'recompose';
import { withQuery } from '../../core/ReactHooksHOC';
import { GET_ME_QUERY } from '../../schema/MetaQuery';

const getUpdatedLinks = (links) =>
  links
    ? links
        .filter(({ partnerAccount }) => !!partnerAccount)
        .sort((a, b) =>
          a.partnerAccount.name > b.partnerAccount.name ? 1 : -1,
        )
    : links;

const calculatedProps = withProps(({ data }) => {
  let me = data?.metaQuery?.me || {};
  const links = getUpdatedLinks(me.links);

  return { me: { ...me, links } };
});

const withMe = compose(withQuery(GET_ME_QUERY), calculatedProps);

export default withMe;
